import { useEffect } from "react";
import { useCallbackState } from "./useCallbackState";

export default function useStorageState(
  AsyncStorage,
  key,
  defaultValue,
  initialValue,
) {
  // Initialize the state with the default value or AsyncStorage value
  const [state, setState] = useCallbackState(
    initialValue !== undefined ? initialValue : defaultValue,
  );

  useEffect(() => {
    // Retrieve the value from AsyncStorage when the component mounts
    loadValue();
  }, [key, defaultValue]);

  const loadValue = async () => {
    if (AsyncStorage) {
      try {
        const storedValue = await AsyncStorage.getItem(key);
        setState(storedValue !== null ? JSON.parse(storedValue) : defaultValue); // Parse the value if it's stored as a JSON string
      } catch (error) {
        console.error("Error loading value from AsyncStorage:", error);
      }
    } else {
      setState(defaultValue);
    }
  };

  const saveValue = async (value) => {
    setState(value, async (newValue) => {
      if (AsyncStorage) {
        try {
          // Save the updated state to AsyncStorage
          await AsyncStorage.setItem(key, JSON.stringify(newValue));
        } catch (error) {
          console.error("Error saving value to AsyncStorage:", error);
        }
      }
    });
  };

  return [state, saveValue, setState];
}
